uniform float uTime;
uniform float uProgress;
uniform float uPointSizeEffect;
uniform float uAngle;

attribute vec2 aDelayDuration;
attribute vec3 aStartLoading;
attribute vec3 aEndPos;
attribute vec3 aStartColor;
attribute vec3 aEndColor;

varying vec3 vColor;
varying float vRandom;
attribute float aRandom;

// Import noise function (using vite-plugin-glsl to include standard noise or copy)
// For now, simple rand/noise
float random(vec2 st) {
    return fract(sin(dot(st.xy, vec2(12.9898,78.233))) * 43758.5453123);
}

// Cubic Ease In Out
float easeExpoInOut(float t) {
    return t == 0.0 ? 0.0 : t == 1.0 ? 1.0 : t < 0.5 ? pow(2.0, 20.0 * t - 10.0) / 2.0 : (2.0 - pow(2.0, -20.0 * t + 10.0)) / 2.0;
}

vec2 rotate2D(vec2 _st, float _angle){
    _st -= 0.5;
    _st =  mat2(cos(_angle),-sin(_angle),
                sin(_angle),cos(_angle)) * _st;
    _st += 0.5;
    return _st;
}

// Simplex 3D Noise 
// vec3 snoiseVec3( vec3 x ){ ... } // Need external noise or implementation

void main() {
    float tProgress = clamp(uProgress - aDelayDuration.x, 0.0, aDelayDuration.y) / aDelayDuration.y;
    tProgress = easeExpoInOut(tProgress);

    vec3 transformed = vec3(0.0);

    if(tProgress < 0.5){ 
         vec3 pos = aStartLoading;
         // Placeholder for complex curl noise logic from original
         // float n = noise(aStartLoading.yx);
         // Simplified loading animation for now
         transformed = mix(pos * 3.0, pos, tProgress * 2.0);
    } else {
         transformed = mix(aStartLoading, aEndPos, tProgress);
    }
    
    // vColor = mix(aStartColor, aEndColor, tProgress);
    // vColor = mix(aStartColor, aEndColor, tProgress);
    vColor = aStartColor; // Simplified
    vRandom = aRandom;

    vec4 mvPosition = modelViewMatrix * vec4(transformed, 1.0);
    gl_PointSize = (1200.0 / -mvPosition.z); // Increased from 400.0 for better visibility
    gl_Position = projectionMatrix * mvPosition;
}
